import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import useTheme from "../../common/hooks/useTheme";
import { Box } from "@mui/material";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

interface CustomButtonProps extends ButtonProps {
  label: string;
  icon?: React.ReactNode;
  sx?: SxProps<Theme>;
  isDisable?: boolean;
  type?: "button" | "submit" | "reset";
  customLabelStyles?: React.CSSProperties;
  "data-agent-target"?: string;
}

const PrimaryButton: React.FC<CustomButtonProps> = ({
  onClick,
  label,
  sx,
  icon,
  isDisable = false,
  type = "button",
  customLabelStyles = {},
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Button
      type={type}
      disableTouchRipple={true}
      onClick={onClick}
      sx={{
        height: "38px",
        // border: `1px solid ${theme.colors_ds.PRIMARY_TEXT_MAIN}`,
        textTransform: "none",
        borderRadius: "8px",
        fontFamily: "var(--font-Medium)",
        fontSize: "14px",
        padding: "8px 16px",
        backgroundColor: isDisable
          ? theme.colors_ds.NEUTRAL_BORDER_WEAK
          : theme.colors_ds.PRIMARY_TEXT_MAIN,
        color: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "&:hover": {
          backgroundColor: theme.colorTokens.P[70],
        },
        "&:active": {
          backgroundColor: theme.colorTokens.P[90],
        },
        "& .MuiTouchRipple-root": {
          color: theme.colorTokens.P[20],
        },
        ...sx, // Allow additional styles to be passed via props
      }}
      disabled={isDisable}
      {...rest}
    >
      {icon && (
        <Box
          sx={{
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
      )}
      <Box style={{ flex: 1, ...customLabelStyles }}>{label}</Box>
    </Button>
  );
};

export default PrimaryButton;
